import { LinearProgress } from '@hyperflake/react-ui-library';
import UpdateProjectInstallationForm from 'modules/project-installation/components/UpdateProjectInstallationForm/UpdateProjectInstallationForm';
import useProjectInstallationData from 'modules/project-installation/hooks/useProjectInstallationData';
import { PageTemplate } from 'modules/shared/features/content';
import { useParams } from 'react-router-dom';

const UpdateProjectInstallationPage = () => {
    const { clientInstallationId, projectInstallationId } = useParams();
    const {
        projectInstallation: initialData,
        isLoading,
        setData,
    } = useProjectInstallationData(clientInstallationId!, projectInstallationId!);
    return (
        <>
            {isLoading ? (
                <LinearProgress />
            ) : (
                <PageTemplate>
                    <UpdateProjectInstallationForm
                        clientInstallationId={clientInstallationId}
                        projectInstallationId={projectInstallationId}
                        initialData={initialData}
                        setData={setData}
                    />
                </PageTemplate>
            )}
        </>
    );
};

export default UpdateProjectInstallationPage;
